import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BFXAppNotificationType } from "shared/cubiq-services";

import * as SettingsConst from "./model/bfx-settings-constants";

import { BfxNotificationSettingsBaseComponent } from "app/bfx-user-settings/bfx-notification-settings-base.component";
import { BfxUserNotificationSettingsService } from "app/bfx-user-settings/services/bfx-user-notification-settings.service";
import { BFXNotificationType } from "../../shared/cubiq-services/model/core/notifications/BFXNotificationType";
import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

@Component({
  selector: "bfx-notification-settings-bmark",
  templateUrl: "./html/bfx-notification-settings-order.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BfxNotificationSettingsBMarkComponent extends BfxNotificationSettingsBaseComponent {
  public nativeDesktop: boolean = false;

  constructor(
    public translate: TranslateService,
    settingsService: BfxUserNotificationSettingsService,
    cd: ChangeDetectorRef,
  ) {
    super(translate, settingsService, cd);
    this.nativeDesktop = NativeDesktopSupport.isNativeDesktopContainer();
  }

  protected isSupportedPopupType(type: BFXNotificationType): boolean {
    return SettingsConst.BMARK_NOTIFICATION_TYPES.has(type);
  }

  protected isSupportedAppType(type: BFXAppNotificationType): boolean {
    return SettingsConst.BMARK_APP_NOTIFICATION_TYPES.has(type);
  }
}
